/**
 * 基于对Storage和Map封装的缓存类。
 */
import localStore from 'store2'; //  使用了

let cacheMap = new Map()
let timeoutDefault = 1200

/**
 * 根据缓存Key判断本地缓存内容是否已经过期
 * @param key
 * @returns {boolean}
 */
function isTimeOut(key) {
    const data = key.startsWith('_') ? localStore.get(key) : cacheMap.get(key)
    if (!data) return true
    if (data.timeout === 0) return false //    如果过期时间为0，那么在Map中不会过期
    const currentTime = Date.now()
    const overTime = (currentTime - data.createTime) / 1000
    if (overTime > data.timeout) {
        cacheMap.delete(key)
        if (key.startsWith('_')) {
            try {
                localStore.remove(key)
            } catch (e) {
                console.log(e)
            }
        }
        return true
    }
    return false
}

/**
 * 缓存内容类。内容包括：缓存的具体内容、缓存过期时间（单位秒）、添加缓存时的时间
 * @param data      缓存的具体内容
 * @param timeout   缓存过期时间（单位秒）
 * @returns {{data: *, createTime: number, timeout: *}}
 */
function setCacheCell(data, timeout) {
    return {
        data: data,
        timeout: timeout,
        createTime: Date.now()
    };
}

class MinCache {
    constructor(timeout) {
        try {
            //  遍历本地缓存，将所有缓存保存到Map中
            localStore.each(function (value, key) {
                cacheMap.set(key, value)
            })
        } catch (e) {
            console.log(e)
        }
        timeoutDefault = timeout
    }

    /**
     * 生成某个缓存
     * @param key
     * @param data
     * @param timeOut
     * @returns {null}
     */
    set(key, data, timeOut = timeoutDefault) {
        const cacheCell = setCacheCell(data, timeOut)
        let cache = null
        if (key.startsWith('_')) {
            try {
                localStore.set(key, cacheCell)
                cache = cacheMap.set(key, cacheCell)
            } catch (e) {
                console.log(e)
            }
        } else {
            cache = cacheMap.set(key, cacheCell)
        }
        return cache
    }

    /**
     * 获得某个缓存
     * @param key
     * @returns {*}
     */
    get(key) {
        if (isTimeOut(key)) {
            return null;
        }
        if (key.startsWith('_')) {
            return localStore.get(key).data;
        } else {
            return cacheMap.get(key).data;
        }
    }

    /**
     * 删除某个缓存
     * @param key
     * @returns {boolean}
     */
    delete(key) {
        let value = false
        if (key.startsWith('_')) {
            try {
                localStore.remove(key)
                value = cacheMap.delete(key)
            } catch (e) {
                console.log(e)
            }
        } else {
            value = cacheMap.delete(key)
        }
        return value
    }

    /**
     * 判断是否存在
     * @param key
     * @returns {boolean}
     */
    has(key) {
        return !isTimeOut(key)
    }

    //  清除所有缓存
    clear() {
        let value = false
        try {
            localStore.clearAll()
            cacheMap.clear()
            value = true
        } catch (e) {
            console.log(e)
        }
        return value
    }
}

MinCache.install = function (Vue, {
    timeout = 1200
} = {}) {
    Vue.prototype.$cache = new MinCache(timeout)
}

export default MinCache